import React from "react";

import {
  Typography,
  Box,
  Stack,
  IconButton,
  InputAdornment,
  Paper,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { useSearchParams, Link as RouterLink } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import logo from "../../../logo.svg";

import { FormProvider, RHFTextField } from "../../../components/hook-form";

import Iconify from "../../../components/Iconify";
import Page404 from "../../../pages/Page404";

import { resetPassword } from "../../../redux/features/authSlice";
import { EntityType, RegistrationStatus, UserType } from "../../../common/enum";
import { updateRegistrationDetail } from "../../../Containers/OnBoarding/slice";

const SetNewPassword = () => {
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get("resetToken");
  const addToken = searchParams.get("addToken");
  const userType = searchParams.get("userType");
  // const email = searchParams.get("email");
  // const email = window.location.href.split("&")[2].slice(6);

  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [onSuccess, setOnSuccess] = React.useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    translate,
    auth: { loading },
  } = useSelector((state) => state);

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  const SetPasswordSchema = Yup.object().shape({
    password: Yup.string()
    .required(
      "Palavra-passe é obrigatória"
    )
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[.@$!%*#?&])[A-Za-z\d.@$!%*#?&]{9,}$/,
      {
        message:
        "A palavra-passe deve ter no mínimo 8 caracteres\n, com letras, números e símbolos",
        excludeEmptyString: false,
      }
    ),
    confirmPassword: Yup.string()
      .required("Por favor, reescreva a palavra-passe")
      .oneOf([Yup.ref("password"), null], "As palavras-passe devem corresponder"),
  });

  const setBranchPasswordSchema = Yup.object().shape({
    password: Yup.string().required(
      "Palavra-passe é obrigatória"
    )
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[.@$!%*#?&])[A-Za-z\d.@$!%*#?&]{9,}$/,
      {
        message:
        "A palavra-passe deve ter no mínimo 8 caracteres\n, com letras, números e símbolos",
        excludeEmptyString: false,
      }
    ),
    confirmPassword: Yup.string()
      .required("Por favor, reescreva a palavra-passe")
      .oneOf([Yup.ref("password"), null], "As palavras-passe devem corresponder"),
  });

  const setManagerPasswordSchema = Yup.object().shape({
    name: Yup.string().required(
      `O campo ${t("name")} é de preenchimento obrigatório`
    ),
    password: Yup.string()
    .required(
      "Palavra-passe é obrigatória"
    )
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[.@$!%*#?&])[A-Za-z\d.@$!%*#?&]{9,}$/,
      {
        message:
        "A palavra-passe deve ter no mínimo 8 caracteres\n, com letras, números e símbolos",
        excludeEmptyString: false,
      }
    ),
    confirmPassword: Yup.string()
      .required("Por favor, reescreva a palavra-passe")
      .oneOf([Yup.ref("password"), null], "As palavras-passe devem corresponder"),
  });

  const setSchema = React.useMemo(() => {
    if(userType === UserType.entityManager){
      return setManagerPasswordSchema 
    }
    return setBranchPasswordSchema
  },[userType])

  const defaultValues = {
    password: "",
    confirmPassword: "",
    name: "",
  };

  const methods = useForm({
    resolver: addToken
      ? yupResolver(setSchema)
      : yupResolver(SetPasswordSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
    setError,
  } = methods;

  const onSubmit = async () => {
    
    const value = methods.getValues();

    let data = {};
    if (resetToken) {
      data = {
        password: value.password,
        resetToken,
      };
    } else if (addToken) {
      data = {
        password: value.password,
        resetToken: addToken,
        status: RegistrationStatus.active,
      };
      if(userType === UserType.entityManager){
        data["name"] = value.name;
      }
    }
    await dispatch(resetPassword({ data }))
      .unwrap()
      .then((res) => {
        setOnSuccess(true);
      })
      .catch((error) => {
        alert("unable to reset password");
      });
  };

  const style = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };


  return (
    <>
      {" "}
      {(resetToken === null && addToken === null) ||
      (resetToken !== null &&
        resetToken.length === 0 &&
        addToken !== null &&
        addToken.length === 0) ? (
        <Page404 />
      ) : (
        <Stack sx={style}>
          <Box sx={{ textAlign: "center" }}>
            <Box mb={8} mt={2} pr={4}>
              <img src={logo} alt="SVG as an image"></img>
            </Box>

            <Paper
              variant="outlined"
              sx={{ maxWidth: 550, padding: "16px", borderRadius: "10px" , maxWidth: "300px"}}
              className="TypographyAlertaEmail"
            >
              {onSuccess === false ? (
                <>
                  <Typography pb={4} fontWeight="400" variant="h4" fontSize="18px !important" >
                    {resetToken ? t("resetYourPassword") : t("setYourPassword")}
                  </Typography>

                  <FormProvider
                    methods={methods}
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <Stack spacing={3} pb="30px">
                      {userType === UserType.entityManager && (
                        <RHFTextField
                          name="name"
                          label={t("name")}
                          type="text"
                        />
                      )}
                      <RHFTextField
                        
                        name="password"
                        label={t("enterNewPassword")}
                        type={showPassword ? "text" : "password"}
                        
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                              >
                                <Iconify
                                  icon={
                                    showPassword
                                      ? "eva:eye-fill"
                                      : "eva:eye-off-fill"
                                  }
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <RHFTextField
                        name="confirmPassword"
                        label={t("confirmNewPasssword")}
                        type={showConfirmPassword ? "text" : "password"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  setShowConfirmPassword(!showConfirmPassword)
                                }
                                edge="end"
                              >
                                <Iconify
                                  icon={
                                    showConfirmPassword
                                      ? "eva:eye-fill"
                                      : "eva:eye-off-fill"
                                  }
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Stack>
                    <LoadingButton sx={{
            borderRadius:'4px'
          }}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      loading={loading}
                    >
                      {t("confirm")}
                    </LoadingButton>
                  </FormProvider>
                </>
              ) : (
                <>
                  <Typography pb={4} fontWeight="400" variant="h4" fontSize="18px !important">
                    {t("passwordChanged")}
                  </Typography>
                  {/* <Typography pb={4} variant="body1">
                    {resetToken
                      ? t("passwordSuccessfullyChange")
                      : t("passwordSuccessfullySave")}
                  </Typography> */}
                  <Button
                    to="/"
                    size="large"
                    variant="contained"
                    component={RouterLink}
                    sx={{
                      textTransform: "none",
                      "&:hover": {
                        color: "#ffffff",
                      },
                      borderRadius:"4px"
                    }}
                  >
                    {t("goToHome")}
                  </Button>
                </>
              )}
            </Paper>
          </Box>
        </Stack>
      )}
    </>
  );
};

export default SetNewPassword;
